import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Chapter } from "../components/Chapter";
import { RealScreen } from "../components/UIFragment";

const EASE = [0.16, 1, 0.3, 1];

// Everything connects — one place for the whole kitchen.
export const SceneConnects = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const winY = useTransform(scrollYProgress, [0, 1], ["4%", "-4%"]);

  return (
    <section
      id="connects"
      data-scene
      ref={ref}
      className="relative px-6 py-14 md:px-12 md:py-24 lg:px-24"
    >
      <div className="mx-auto w-full max-w-[1600px]">
        <Chapter title="Everything in one place" />

        <div className="mx-auto max-w-4xl text-center">
          <h2 className="font-display text-6xl font-black leading-[0.92] tracking-tighter text-[#1b1a18] sm:text-7xl">
            The whole kitchen, in one view.
          </h2>
        </div>

        <motion.div
          style={{ y: winY }}
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-12%" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mx-auto mt-10 w-full max-w-[1600px]"
        >
          <RealScreen
            src="/generated/real_inventory.webp"
            alt="MiseOne — Inventory: the whole kitchen's stock in one view"
            testId="connects-app-screenshot"
          />
        </motion.div>
      </div>
    </section>
  );
};
